import React from "react";
import styles from "./Banner.module.css";
import { useAuth } from "../../../context/AuthContext";

export default function Banner() {
  
    const { setAuthModal, userdata } = useAuth();
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent2}>About </span>{" "}
            <span className={styles.accent}>Us</span>
          </h1>
          <p>
            IMPARC (Ignited Minds Professional & Academic Research Consortium) is a global academic platform committed to strengthening research ecosystems, enabling mentorship-driven growth, and building collaborative academic networks across institutions, researchers, and industry professionals.<br/><br/>
            Established under Ignited Minds Edutech Pvt. Ltd., IMPARC bridges academia, policy, and innovation to create measurable academic and institutional impact.

          </p>
          <div className={styles.heroActions}>
            
            <button 
                  onClick={() => setAuthModal({ open: true, tab: "signup" })}
            
            className={styles.button}>Join Our Community</button>
          </div>
        </div>
      </div>
    </section>
  );
}
